<template>

    <form novalidate class="md-layout" @submit.prevent="validateUser">

      <div class="md-layout-item md-elevation-0">   

        <md-card class="md-elevation-0 m-5">
          <md-card-header class="md-layout md-alignment-center-left justify header-bg">
            Declaración Jurada de Origen de Fondos
          </md-card-header>
          <md-card-content>
          
              <p align="justify">
                  Ante cualquier duda, comuníquese con su promotor.
              </p>
                      
          </md-card-content> 
        </md-card>

        <md-card class="md-elevation-0 m-5">
          <md-card-header class="md-layout md-alignment-center-left justify">
            Glosario
          </md-card-header>
          <md-card-content>
            <p align="justify">
              <table>
                <tr>
                  <td valign="top">Ejecutante:</td>
                  <td>persona que realiza físicamente la transacción monetaria.</td>
                </tr>
                <tr>
                  <td valign="top">Ordenante:</td>
                  <td>persona que ordena realizar la suscripción.</td>
                </tr>
                <tr>
                  <td valign="top">Beneficiario:</td>
                  <td>a favor de quién se realiza la suscripción.</td>
                </tr>
              </table>  
            </p>              
                    
          </md-card-content> 
        </md-card> 

        <md-card class="md-elevation-0 m-5" :class="getValidationClass('ejecutanteordenantebeneficiario')">
          <md-card-header class="md-layout md-alignment-center-left justify">
            Es usted el ejecutante, ordenante y beneficiario de esta suscripción.
          </md-card-header>
          <md-card-content>
                      
              <div>
                <md-checkbox v-model="form.ejecutanteordenantebeneficiario" :disabled="isDisabled" value="Si">Sí</md-checkbox>
                <md-checkbox v-model="form.ejecutanteordenantebeneficiario" :disabled="isDisabled" value="No">No</md-checkbox>
              </div>       

              <div class="radioform" :class="getValidationClass('ejecutanteordenantebeneficiario')">
                <span class="md-error" v-if="!$v.form.ejecutanteordenantebeneficiario.required">Esta respuesta es obligatoria.</span>
              </div>

          </md-card-content> 
        </md-card>            

      <Botonera :form="form" :back="back" :Bottontitle="'Siguiente'"/>   

      </div>

    </form>

</template>

<style lang="scss" scoped>
  //@import "~vue-material/theme/engine";

</style>

<script>
import { validationMixin } from 'vuelidate'
// import { alpha } from '../variables'
import {
  required,
//   minLength,
//   numeric,
} from 'vuelidate/lib/validators'


export default {
  mixins: [validationMixin],
  props:{isDisabled: Boolean},
  name: 'Item17',
  data: () => ({
    form:{
    }
  }),

  mounted: function(){
    this.form = this.$store.state.item.item17
    //this.$store.dispatch("back", false);
  },
  validations(){
    var validate = {
      form: {
        ejecutanteordenantebeneficiario: {required,},
      }        
    }
    return validate;
  },
  methods: {
    back () {
      this.$emit('setBack', {id: this.$options.name})
      this.form = this.$store.state.item.item17
    },       
    ChangeOption(item){
      if(item != "0"){
        this.form.mancomunosdes = null;
      }
    },
    validateUser () {
      this.$v.$touch()

      if (!this.$v.$invalid) {
        var index = "0"
        if(this.form.ejecutanteordenantebeneficiario == "No"){
          index = "18"
        }else{
          index = "19"
        }

        this.$emit('setSaveForm', {id:"17", form: this.form, index: index}); 

      }

    },
    getValidationClass (fieldName) {
      const field = this.$v.form[fieldName]

      if (field) {
        return {
          'md-invalid': field.$invalid && field.$dirty
        }
      }
    }
     
  },
  computed: {
   
    isRequired:function(){
      if(this.$route.params.token != null){
        return false
      }
      return true
    },
    isVisible:function(){
      if(this.$route.params.token != null){
        return false
      }
      return true
    }

  },
  components:{
    "Botonera": () => import('./Botonera.vue')
  }
}
</script>
